/* eslint-disable */

import axios from 'axios'

export default {
  getBenefitsCities({ commit, dispatch }, item) {
    let api = process.env.API_VIVEMAS + '/cities'
    return new Promise((resolve, reject) => {
      
      axios.get(api, item)
        .then(res => {
                    
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/popupciudad/actions.js